import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import logo from '../assets/LED-Speed-Signs-Logo.png';
import API_BASE_URL from '../config';
import { TextField, Button, CircularProgress } from '@mui/material';

const InspectionSignIn = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const response = await fetch(`${API_BASE_URL}/users/signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, password, deviceInfo: { portal: 'inspection' } })
      });

      if (response.status === 400 || response.status === 401) {
        setErrorMessage('Invalid credentials. Please try again.');
        return;
      }
      if (!response.ok) {
        setErrorMessage('Unable to login. Please try again later.');
        return;
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('portal', 'inspection');
      localStorage.setItem('primaryColor', data.primaryColor || '#0f0f0f');
      localStorage.setItem('secondaryColor', data.secondaryColor || '#1a1a1a');
      navigate('/inspection');
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      margin: 0,
      padding: 0,
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#ececec',
        padding: '24px 20px',
        borderRadius: '10px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        width: '400px',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100vh - 32px)',
        overflowY: 'auto',
        zIndex: 10
      }}>
        <img src={logo} alt="LSS Logo" className="logo" style={{ maxWidth: '70%', height: 'auto' }} />
        <h2 style={{ marginTop: 8, marginBottom: 20, color: '#111', fontSize: '1.35rem' }}>Inspection Sign In</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <TextField
              fullWidth
              label="ID"
              variant="outlined"
              value={id}
              onChange={(e) => setId(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <TextField
              fullWidth
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className="btn"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'SIGN IN'}
          </Button>
        </form>
        <Button
          onClick={() => navigate('/landing')}
          variant="outlined"
          color="primary"
          style={{ marginTop: '10px' }}
          fullWidth
        >
          Back
        </Button>
        {errorMessage && (
          <p style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default InspectionSignIn;
